import { createSlice } from "@reduxjs/toolkit";
import _ from "lodash";

import { CheckoutState } from "./checkout.types";

const initialState = {
  stripePK: {
    error: null,
    key: "",
    isProcessing: false,
  },
  information: {
    contact: {
      email: "",
      keepMeUpToDate: false,
    },
    shippingAddress: {
      id: "",
      firstname: "",
      lastname: "",
      company: "",
      line1: "",
      line2: "",
      country: "",
      state: "",
      city: "",
      postal_code: "",
      phone: "",
    },
  },
  shipping: {
    method: "",
    price: undefined,
  },
  payment: {
    isBeingProcessed: false,
    sameAsShippingAddress: "",
    method: {
      type: "",
      info: {},
    },
    billingAddress: {
      firstname: "",
      lastname: "",
      company: "",
      line1: "",
      line2: "",
      country: "",
      state: "",
      city: "",
      postal_code: "",
      phone: "",
    },
    remember: false,
  },
} as CheckoutState;

const checkoutSlice = createSlice({
  name: "checkout",
  initialState,
  reducers: {
    // Get Stripe PK
    getStripePKStart: (state, action) => {
      state.stripePK.isProcessing = true;
    },
    getStripePKSuccess: (state, action) => {
      state.stripePK.key = action.payload;
      state.stripePK.error = null;
      state.stripePK.isProcessing = false;
    },
    getStripePKFailure: (state, action) => {
      state.stripePK.key = "";
      state.stripePK.error = action.payload;
      state.stripePK.isProcessing = false;
    },

    submitInfo: (state, action) => {
      state.information = action.payload;
    },
    submitInfoContact: (state, action) => {
      state.information.contact = action.payload;
    },
    submitInfoShippingAddress: (state, action) => {
      state.information.shippingAddress = action.payload;
    },
    submitShipping: (state, action) => {
      state.shipping = action.payload;
    },
    submitPaymentMethod: (state, action) => {
      state.payment.method.type = action.payload;
    },
    saveCard: (state, action) => {
      state.payment.method.info = action.payload;
    },
    submitBillingAddress: (state, action) => {
      state.payment.billingAddress = action.payload;
    },
    setPaymentIsBeingProcessed: (state, action) => {
      state.payment.isBeingProcessed = action.payload;
    },
    setRemember: (state, action) => {
      state.payment.remember = action.payload;
    },
  },
});

export const checkoutActions = checkoutSlice.actions;

export default checkoutSlice.reducer;
